import React from 'react';
import UiBox from '../Box';

const spacingValues = {
  xs: '12px',
  sm: '16px',
  md: '24px',
  lg: '28px',
  xl: '32px',
};

type Props = {
  size: keyof typeof spacingValues;
};

const UiSpacer = ({ size = 'md' }: Props) => {
  return <UiBox styles={{ height: spacingValues[size], width: spacingValues[size] }} />;
};

export default UiSpacer;
